// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3EpzS","overflowing":"ReadFullNote_overflowing__lpXr7"};